import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import React, { Component } from 'react';
import types from 'prop-types';
import _ from 'lodash';
import { styled, StyleSheet } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  container: {
    userSelect: 'none',
    cursor: 'pointer',
    color: 'blue',
    width: 'auto',
    height: 'auto',
    padding: '.5rem',
    display: 'inline-block',
    backgroundColor: 'currentColor',
    borderRadius: '.4rem',
    border: '1px solid currentColor',
    whiteSpace: 'nowrap',
    position: 'relative',
    '&:hover': {
      opacity: 0.85
    }
  },
  containerDisabled: {
    color: 'grey',
    cursor: 'not-allowed',
    opacity: 0.5,
    '&:hover': {
      opacity: 0.5
    }
  },
  containerInverted: {
    backgroundColor: 'transparent',
    '&:hover': {
      opacity: 0.5
    }
  },
  content: {
    cursor: 'pointer',
    color: 'white',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  contentLoading: {
    opacity: 0
  },
  contentInverted: {
    color: 'currentColor'
  },
  wrapLoading: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white'
  },
  wrapLoadingInverted: {
    color: 'blue'
  },
  icon: {},
  iconLeft: {},
  iconRight: {},
  iconDisabled: {},
  iconInverted: {}
});
var Button = (_dec = styled(defaultStyles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.renderIcon = _this.renderIcon.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Button, [{
    key: "handleClick",
    value: function handleClick(event) {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          preventDefault = _this$props.preventDefault,
          stopPropagation = _this$props.stopPropagation;
      if (onClick) onClick(event);

      if (event.defaultPrevented) {
        preventDefault && event.preventDefault();
        stopPropagation && event.stopPropagation();
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(icon, position) {
      var _this$props2 = this.props,
          s = _this$props2.styles,
          isDisabled = _this$props2.isDisabled,
          isInverted = _this$props2.isInverted;
      return !icon ? null : React.createElement("div", s('icon', "icon".concat(position === 'left' ? 'Left' : 'Right'), {
        iconDisabled: isDisabled,
        iconInverted: isInverted
      }), icon);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          s = _this$props3.styles,
          Container = _this$props3.Container,
          onClick = _this$props3.onClick,
          isDisabled = _this$props3.isDisabled,
          isInverted = _this$props3.isInverted,
          isLoading = _this$props3.isLoading,
          iconLeft = _this$props3.iconLeft,
          iconRight = _this$props3.iconRight,
          stopPropagation = _this$props3.stopPropagation,
          preventDefault = _this$props3.preventDefault,
          children = _this$props3.children,
          Loading = _this$props3.Loading,
          className = _this$props3.className,
          props = _objectWithoutProperties(_this$props3, ["styles", "Container", "onClick", "isDisabled", "isInverted", "isLoading", "iconLeft", "iconRight", "stopPropagation", "preventDefault", "children", "Loading", "className"]);

      var _s = s('container', {
        containerDisabled: isDisabled,
        containerDisabledInverted: isDisabled && isInverted,
        containerInverted: isInverted,
        containerLoading: isLoading
      }),
          defaultClassNames = _s.className,
          styleProps = _objectWithoutProperties(_s, ["className"]);

      var buttonClassNames = "".concat(className, " ").concat(defaultClassNames);
      return React.createElement(Container, _extends({}, props, styleProps, {
        className: buttonClassNames,
        onClick: isDisabled || isLoading ? undefined : this.handleClick
      }), React.createElement("div", s('content', {
        contentInverted: isInverted,
        contentLoading: isLoading
      }), this.renderIcon(iconLeft, 'left'), React.createElement("span", null, children), this.renderIcon(iconRight, 'right')), !!isLoading && React.createElement("span", s('wrapLoading', {
        wrapLoadingInverted: isInverted
      }), React.createElement(Loading, {
        isInverted: isInverted
      })));
    }
  }]);

  return Button;
}(Component), _defineProperty(_class2, "defaultProps", {
  onClick: _.noop,
  isDisabled: false,
  isInverted: false,
  isLoading: false,
  iconLeft: undefined,
  iconRight: undefined,
  Container: 'button',
  preventDefault: true,
  stopPropagation: false,
  Loading: function Loading() {
    return React.createElement("span", null, "Loading...");
  }
}), _temp)) || _class);
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The container wrapping the inside component. */
  Container: types.oneOfType([types.func, types.string]),

  /** Action to run on submit. */
  onClick: types.func,

  /** Whether or not tabs should animate on change. */
  isDisabled: types.bool,

  /** Whether or not to invert ("ghost") the button. */
  isInverted: types.bool,

  /** Whether or not to show the buttons loading state */
  isLoading: types.bool,

  /** Accepts the icon type constraints. */
  iconLeft: types.node,
  iconRight: types.node,

  /** To enable event bubbling & prevent default click behaviour */
  stopPropagation: types.bool,
  preventDefault: types.bool,

  /** Button loading state */
  Loading: types.func
} : {};
export default Button;